import { Box, FormControl, FormHelperText, Stack, Typography, CircularProgress } from "@mui/material";
import React, { useState, useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import UploadFileIcon from '@mui/icons-material/UploadFile'; 
import { useSnackbar } from "notistack";

export default function FormFileField({label,inputProps={error:false,helperText:"",value:null,onChange:()=>{}}}){
    // const [file,setFile] = useState();
    const [loading,setLoading]=useState(false);
const { enqueueSnackbar } = useSnackbar();


 const displayLabel = label || "Upload File";
    const showError = inputProps.error;

    const onDrop = useCallback(acceptedFiles => {
        setLoading(true)
        // Do something with the files
        console.log(acceptedFiles);
        // setFile(acceptedFiles[0])
        inputProps.onChange(acceptedFiles[0])
        setLoading(false)
      }, [inputProps])
    
   const onDropRejected = useCallback((fileRejections) => {
    const error = fileRejections[0]?.errors?.[0];

    if (error?.code === "file-too-large") {
        enqueueSnackbar(`${label} file must be less than 5MB.`, {
            variant: "error",
        });
    }
}, [enqueueSnackbar, label]);

      const {getRootProps,getInputProps,} = useDropzone({onDrop,maxFiles: 1,  onDropRejected,accept: inputProps.accept,maxSize: inputProps.maxSize,});

    return(
        <Stack direction={"column"} spacing={1}>
            <Typography variant="label">{displayLabel}</Typography>
            <FormControl error={showError}>
                <Box
                    sx={{
                        background: "#F8F8F8 0% 0% no-repeat padding-box",
                        border: "1px dashed",
                        borderColor: showError ? "red" : "#818E94",
                        borderRadius: 1,
                        minWidth: 290,
                        minHeight: "46px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: "24px",
                        cursor: "pointer",
                    }}
                    {...getRootProps()}
                >
                    <input {...getInputProps()} />
                    {loading ? (
                        <CircularProgress size={30} sx={{ color: "red" }} />
                    ) : (
                        <>
                            {inputProps.value && inputProps.value.name ? (
                                <Typography
                                    variant="placeHolder"
                                    sx={{
                                        fontSize: 14,
                                        lineHeight: 1.1,
                                        wordBreak: "break-all",
                                        whiteSpace: "normal",
                                    }}
                                >
                                    {inputProps.value.name}
                                </Typography>
                            ) : (
                                <>
                                    <UploadFileIcon sx={{ mr: 0.5, color: "#B0B0B0" }} />
                                    <Typography
                                        variant="placeHolder"
                                        sx={{
                                            color: "text.disabled",
                                            lineHeight: 1.1,
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        Choose file from storage
                                    </Typography>
                                </>
                            )}
                        </>
                    )}
                </Box>
                <FormHelperText>{inputProps.helperText}</FormHelperText>
            </FormControl>
        </Stack>
    )
}


